import { Group, Stack, Text } from '@mantine/core'
import { Link } from 'react-router-dom'

type LegalLink = { label: string; to: string }

type LegalLinksProps = {
  orientation?: 'horizontal' | 'vertical'
  size?: 'xs' | 'sm' | 'md'
  color?: string
  wrap?: boolean
  links?: LegalLink[]
}

const DEFAULT_LINKS: LegalLink[] = [
  { label: 'Условия использования', to: '/legal/terms' },
  { label: 'Политика конфиденциальности', to: '/legal/privacy' }
]

export function LegalLinks({
  orientation = 'horizontal',
  size = 'xs',
  color = 'dimmed',
  wrap = true,
  links = DEFAULT_LINKS
}: LegalLinksProps) {
  const linkProps = { style: { textDecoration: 'none' } }
  const linkItems = links.map((link) => (
    <Text key={link.to} component={Link} to={link.to} size={size} c={color} {...linkProps}>
      {link.label}
    </Text>
  ))

  if (orientation === 'vertical') {
    return <Stack gap={4}>{linkItems}</Stack>
  }

  return (
    <Group gap="xs" wrap={wrap ? 'wrap' : 'nowrap'} align="center">
      {linkItems}
    </Group>
  )
}

export type { LegalLink }
export default LegalLinks
